import React from 'react';

/**
 * Progress bar pro "kolik zbývá ze 100%" — STK, servisní interval, palivo apod.
 *
 * `remaining` může být ZÁPORNÉ (expirováno / přesluhuje):
 *   - bar je celý červený (100% wide)
 *   - vpravo se zobrazí negativní procento ("-3 %")
 *   - label se obvykle zobrazí s minusem ("-5 dní")
 *
 * Barevná pravidla:
 *   - remaining < 0  → červená (#EF4444)
 *   - 0–20% zbývá    → oranžová (#FF8A00)
 *   - >20% zbývá     → zelená (#10B981)
 *
 * Pokud chceš jiný (custom) gradient pro speciální případ (např. palivo),
 * předej `color` — přepíše barevnou logiku (kromě expired stavu).
 */
export default function ProgressBarRemaining({ label, remaining, total, color, isDark }) {
    const pct = total > 0 ? (remaining / total) * 100 : 0;
    const expired = pct < 0;
    const fillPct = expired ? 100 : Math.max(0, Math.min(100, pct));

    let barColor;
    if (expired) {
        barColor = '#EF4444';
    } else if (color) {
        barColor = color;
    } else if (pct < 20) {
        barColor = '#FF8A00';
    } else {
        barColor = '#10B981';
    }

    const trackBg = isDark ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.06)';
    const labelColor = isDark ? 'rgba(255,255,255,0.55)' : 'var(--text-secondary)';
    const valueColor = isDark ? '#fff' : 'var(--text-primary)';

    return (
        <div style={{ marginBottom: 10 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11, marginBottom: 4 }}>
                <span style={{ color: labelColor }}>{label}</span>
                <span style={{
                    fontVariantNumeric: 'tabular-nums', fontWeight: 700,
                    color: expired ? '#EF4444' : valueColor,
                }}>
                    {Math.round(pct)} %
                </span>
            </div>
            <div style={{ height: 6, borderRadius: 2, background: trackBg, overflow: 'hidden' }}>
                <div style={{
                    height: '100%', width: `${fillPct}%`,
                    background: barColor, borderRadius: 2,
                    transition: 'width 0.4s, background 0.3s',
                }} />
            </div>
        </div>
    );
}
